export const camelize = function (str) {
  let arr = str.split('-');
  let capital = arr.map((item, index) => index ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() : item);
  // ^-- change here.
  let capitalString = capital.join("");
  return capitalString;
}

export const dependenciesCheck = function () {
  var passed = true;

  for (var i = 0; i < arguments.length; i++) {
    var argBooleanValue = !!(typeof arguments[i] === 'string' || arguments[i] instanceof jQuery ? arguments[i].length : arguments[i]);
    passed = (passed && argBooleanValue);
  }

  return passed;
};

export const isTouchDevice = function () {
  return (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
};

/**
 * Returns a function, that, when invoked, will only be triggered at most once
 * during a given window of time. Normally, the throttled function will run
 * as much as it can, without ever going more than once per `wait` duration;
 * but if you'd like to disable the execution on the leading edge, pass
 *`{leading: false}`. To disable execution on the trailing edge, ditto.
 * @param func
 * @param wait
 * @param options
 * @returns {function(): *}
 */
export const throttle = function (func, wait, options) {
  var context, args, result
  var timeout = null
  var previous = 0
  if (!options) options = {}
  var later = function () {
    previous = options.leading === false ? 0 : Date.now()
    timeout = null
    result = func.apply(context, args)
    if (!timeout) context = args = null
  }
  return function () {
    var now = Date.now()
    if (!previous && options.leading === false) previous = now
    var remaining = wait - (now - previous)
    context = this
    args = arguments
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      result = func.apply(context, args)
      if (!timeout) context = args = null
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining)
    }
    return result
  }
}

export const announcementBarHeight = () => {
  const announcementBar = document.querySelector('.announcement-bar');
  if (announcementBar) {
    return announcementBar.clientHeight;
  } else {
    return 0;
  }
}

export const headerHeight = function () {
  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    const header = siteHeader.querySelector('.header__container');
    if (header) {
      return header.clientHeight + announcementBarHeight();
    } else {
      if (siteHeader.classList.contains('headroom--unpinned')) {
        return 0;
      } else {
        return announcementBarHeight();
      }
    }
  } else {
    return 0;
  }
}

export const removeUnit = function(string) {
  return parseInt(string.replace('px', ''))
}
